import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import HaveQuestions from '@/components/HaveQuestions'
import HtmlContent from '@/components/HtmlContent'
import Title from '@/components/Title'
import { usePage } from '@/hooks'
import React from 'react'
import style from './styles/lecture.module.scss'

const Lecture = (): React.ReactElement => {
  const page = usePage()

  const { config } = page.init_state.global
  const { object } = page?.init_state

  return (
    <>
      <Container className={style.lecture}>
        <BackLink href={config.urban_club} title='Клуб' />
        <span className={style.lecture__date}>{object.date_create}</span>
        <Title type='h1' className={style.lecture__title}>
          {object.title}
        </Title>

        <HtmlContent className={style.content} content={object.detail} />
      </Container>

      <HaveQuestions />
    </>
  )
}

export default Lecture
